<template>
  <div class="plan px-4">
    <div class="display-flex align-center justify-space-between pt-5 pb-4">
      <div class="display-flex align-center gap-8">
        <img src="../../assets/mobile/notification_2.png" width="60" />
        <div>
          <div class="text-poppins-16 text-white">SALVA</div>
          <div class="text-poppins-12">ARTIST</div>
        </div>
      </div>
      <img
        @click="$router.push({ name: 'CommunityMobile' })"
        src="../../assets/mobile/icon/arrow-down-white.svg"
        width="27"
      />
    </div>

    <div class="title font-weight-500 text-white my-4">Choose plan</div>
    <div class="horizontal-scroll mb-5">
      <div
        v-for="i in 4"
        :key="i"
        class="horizontal-scroll__item mr-2 mb-2 plan__item"
      >
        <div class="font-24 font-weight-500 text-white">Loud Pack</div>
        <div>
          <span class="font-20 font-weight-500 text-white">20$/</span>
          <span class="text-poppins-14 text-white">month</span>
        </div>
        <div class="text-poppins-14 text-white my-3">
          Exclusive drops from all my homies!
        </div>
        <div class="text-poppins-4 text-white mb-2">
          Plan features 4 creators
        </div>

        <div
          v-for="i in 3"
          :key="3"
          class="display-flex align-center gap-8 plan__item__user"
        >
          <img src="../../assets/mobile/notification_2.png" width="44" />
          <span class="text-poppins-15 text-white">@salva</span>
        </div>

        <v-btn
          class="btn-detail mx-0 text-white font-weight-500 full-width bg-black"
          @click="$router.push({ name: 'PlanDetailMobile' })"
        >
          Details
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.plan {
  background: linear-gradient(180deg, #2e2e2e 0%, #000 73.5%);
  min-height: 100vh;
  &__item {
    border-radius: 8px;
    background: #714dff;
    padding: 20px;
    &__user {
      border-bottom: 0.5px solid rgba(255, 255, 255, 0.1);
      padding-bottom: 8px;
      padding-top: 8px;
    }
  }
}

.btn-detail {
  border-radius: 60px;
  font-size: 15px;
  line-height: 19px;
  height: 36px;
  margin-top: 36px;
}

.title {
  font-size: 28px;
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// plan.vue?4030b992